import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "../redux/freezeLifecycleSagas";

const DurationFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.freezeLifecycle.filters.durationBuckets);
  const selectedFilters = useSelector(
    (state) => state.freezeLifecycle.selectedFilters.durationBuckets
  );
  const filtersLoading = useSelector((state) => state.freezeLifecycle.filtersLoading);

  return (
    <div className="select-box-no-width">
      <p>Freeze Duration</p>
      {filtersLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedFilters}
          placeholder="Not selected"
          numberDisplayed={0}
          includeSelectAll
          enableOnly
          onSelectChange={(data) =>
            dispatch(actionCreators.updateFilter({ key: "durationBuckets", data }))
          }
        />
      )}
    </div>
  );
};

export default DurationFilter;
